export const translations = {
  en: {
    // Home Page
    title: "Parteezy",
    subtitle: "The Ultimate Party Game",
    createRoom: "Create Room",
    joinRoom: "Join Room",
    enterRoomCode: "Enter Room Code",
    howToPlay: "How to Play",
    howToPlayText: "Create a room, invite friends, and take turns spinning the wheel for truth or dare, drinking challenges, and fun party games!",
    copyright: "© 2024 Parteezy - Party Responsibly",
    
    // Payment Page
    paymentTitle: "Parteezy Premium",
    securePayment: "🔒 Secure Payment Processing",
    securePaymentDesc: "All payments are processed securely through Stripe. Your payment information is encrypted and never stored on our servers.",
    addToCart: "Add to Cart",
    addedToCart: "✓ Added to Cart",
    adding: "Adding...",
    cart: "Cart",
    
    // Private Room
    privateRoom: "Private Room",
    premium: "(Premium)",
    enterRoomPassword: "Enter room password",
    createPrivateRoom: "🔒 Create Private Room",
    roomPassword: "Room Password",
    passwordRequired: "Password is required for private rooms",
    incorrectPassword: "Incorrect password. Please try again.",
    enterPassword: "Enter Password",
    privateRoomAlert: "Private rooms are a Premium feature! Upgrade to create password-protected rooms.",
    privateRoomDescription: "This is a private room. Please enter the password to continue.",
    
    // Language Switcher
    selectLanguage: "Select Language",
    
    // Join Modal
    joinTheGame: "Join the Game",
    enterYourName: "Enter Your Name",
    chooseProfilePicture: "Choose Profile Picture (optional)",
    cancel: "Cancel",
    joinGame: "Join Game",
    joining: "Joining...",
    nameRequired: "Please enter your name",
    failedToJoin: "Failed to join the room. Please try again.",
    
    // Game Room
    roomCode: "Room Code",
    leaveRoom: "Leave Room",
    currentTurn: "Current Turn",
    you: "(You)",
    spinning: "Spinning...",
    
    // Player List
    players: "Players",
    host: "Host",
    currentTurnBadge: "Current Turn",
    away: "Away",
    offline: "Offline",
    joiningBadge: "Joining...",
    noPlayersYet: "No players have joined yet",
    
    // Spin Wheel
    spinTheWheel: "Spin the Wheel",
    wheelSpinning: "Wheel Spinning...",
    soloPlay: "Spin the Wheel (Solo Play)",
    hostSpin: "Spin the Wheel (Host)",
    yourTurn: "It's Your Turn - Spin!",
    waitingForPlayer: "Waiting for Player's Turn",
    waitingForHost: "Waiting for Host to Spin",
    waitingForCurrent: "Waiting for",
    waitingForNext: "Waiting for Next Player",
    
    // Controls
    customizeWheel: "Customize Wheel",
    gameSettings: "Game Settings",
    nextTurn: "Next Turn",
    
    // Result Popup
    spinResult: "Spin Result",
    awesome: "Awesome!",
    letsGo: "Let's go!",
    cheers: "Cheers!",
    
    // Wheel Configuration
    wheelConfiguration: "Wheel Configuration",
    addSegment: "Add Segment",
    segmentText: "Segment Text",
    segmentColor: "Segment Color",
    removeSegment: "Remove",
    save: "Save",
    close: "Close",
    
    // Game Settings
    gameSettingsTitle: "Game Settings ⚙️",
    wheelSize: "Wheel Size",
    small: "Small",
    medium: "Medium",
    large: "Large",
    whoCanSpin: "Who Can Spin The Wheel",
    allPlayers: "All Players (Turn Based)",
    hostOnly: "Host Only",
    wheelTheme: "Wheel Theme",
    classic: "Classic",
    neon: "Neon",
    pastel: "Pastel",
    monochrome: "Monochrome",
    turnOrder: "Turn Order",
    sequential: "Sequential (Next Player)",
    random: "Random",
    
    // Default wheel segments
    defaultSegments: [
      "Take a shot",
      "Drink for 5 seconds",
      "Truth or dare",
      "Skip your turn",
      "Everyone drinks",
      "Choose someone to drink",
      "Finish your drink",
      "Take 2 sips"
    ],
    
    // Error messages
    roomNotFound: "Room Not Found",
    roomNotFoundText: "The game room you're looking for doesn't exist.",
    backToHome: "Back to Home",
    roomLimitReached: "Premium users can manage up to 6 active rooms. Please close some rooms before creating a new one.",
    
    // Loading
    loading: "Loading...",
    creatingRoom: "Creating room...",
    
    // QR Code
    scanToJoin: "Scan to Join",
    
    // Room Management
    myRooms: "My Rooms",
    totalRooms: "Total Rooms",
    activeRooms: "Active Rooms",
    totalPlayers: "Total Players",
    noRoomsYet: "No rooms yet",
    createFirstRoom: "Create your first room to get started!",
    active: "Active",
    inactive: "Inactive",
    created: "Created",
    players: "Players",
    type: "Type",
    lastActivity: "Last Activity",
    deactivate: "Deactivate",
    reactivate: "Reactivate",
    delete: "Delete",
    confirmDeactivateRoom: "Are you sure you want to deactivate this room?",
    confirmDeleteRoom: "Are you sure you want to permanently delete this room?",
    errorDeactivatingRoom: "Failed to deactivate room. Please try again.",
    errorReactivatingRoom: "Failed to reactivate room. Please try again.",
    errorDeletingRoom: "Failed to delete room. Please try again.",
    manageRooms: "Manage Rooms",
    public: "Public",
    private: "Private"
  },
  
  nl: {
    // Home Page
    title: "Parteezy",
    subtitle: "Het Ultieme Feestspel",
    createRoom: "Kamer Maken",
    joinRoom: "Kamer Joinen",
    enterRoomCode: "Voer Kamercode In",
    howToPlay: "Hoe Te Spelen",
    howToPlayText: "Maak een kamer, nodig vrienden uit en wissel af met het draaien van het wiel voor truth or dare, drankuitdagingen en leuke feestspellen!",
    copyright: "© 2024 Parteezy - Drink Verantwoordelijk",
    
    // Payment Page
    paymentTitle: "Parteezy Premium",
    securePayment: "🔒 Veilige Betalingsverwerking",
    securePaymentDesc: "Alle betalingen worden veilig verwerkt via Stripe. Je betalingsinformatie wordt versleuteld en nooit opgeslagen op onze servers.",
    addToCart: "Toevoegen aan Winkelwagen",
    addedToCart: "✓ Toegevoegd aan Winkelwagen",
    adding: "Toevoegen...",
    cart: "Winkelwagen",
    
    // Private Room
    privateRoom: "Privé Kamer",
    premium: "(Premium)",
    enterRoomPassword: "Voer kamer wachtwoord in",
    createPrivateRoom: "🔒 Privé Kamer Maken",
    roomPassword: "Kamer Wachtwoord",
    passwordRequired: "Wachtwoord is verplicht voor privé kamers",
    incorrectPassword: "Onjuist wachtwoord. Probeer opnieuw.",
    enterPassword: "Voer Wachtwoord In",
    privateRoomAlert: "Privé kamers zijn een Premium functie! Upgrade om met wachtwoord beveiligde kamers te maken.",
    privateRoomDescription: "Dit is een privé kamer. Voer het wachtwoord in om door te gaan.",
    
    // Language Switcher
    selectLanguage: "Selecteer Taal",
    
    // Join Modal
    joinTheGame: "Doe Mee Met Het Spel",
    enterYourName: "Voer Je Naam In",
    chooseProfilePicture: "Kies Profielfoto (optioneel)",
    cancel: "Annuleren",
    joinGame: "Doe Mee",
    joining: "Aan het joinen...",
    nameRequired: "Voer je naam in",
    failedToJoin: "Kon niet deelnemen aan de kamer. Probeer opnieuw.",
    
    // Game Room
    roomCode: "Kamercode",
    leaveRoom: "Kamer Verlaten",
    currentTurn: "Huidige Beurt",
    you: "(Jij)",
    spinning: "Aan het draaien...",
    
    // Player List
    players: "Spelers",
    host: "Host",
    currentTurnBadge: "Huidige Beurt",
    away: "Afwezig",
    offline: "Offline",
    joiningBadge: "Aan het joinen...",
    noPlayersYet: "Nog geen spelers toegetreden",
    
    // Spin Wheel
    spinTheWheel: "Draai Het Wiel",
    wheelSpinning: "Wiel Draait...",
    soloPlay: "Draai Het Wiel (Solo Spel)",
    hostSpin: "Draai Het Wiel (Host)",
    yourTurn: "Het Is Jouw Beurt - Draai!",
    waitingForPlayer: "Wachten Op Speler's Beurt",
    waitingForHost: "Wachten Tot Host Draait",
    waitingForCurrent: "Wachten op",
    waitingForNext: "Wachten Op Volgende Speler",
    
    // Controls
    customizeWheel: "Wiel Aanpassen",
    gameSettings: "Spelinstellingen",
    nextTurn: "Volgende Beurt",
    
    // Result Popup
    spinResult: "Draai Resultaat",
    awesome: "Geweldig!",
    letsGo: "Laten we gaan!",
    cheers: "Proost!",
    
    // Wheel Configuration
    wheelConfiguration: "Wiel Configuratie",
    addSegment: "Segment Toevoegen",
    segmentText: "Segment Tekst",
    segmentColor: "Segment Kleur",
    removeSegment: "Verwijderen",
    save: "Opslaan",
    close: "Sluiten",
    
    // Game Settings
    gameSettingsTitle: "Spelinstellingen ⚙️",
    wheelSize: "Wiel Grootte",
    small: "Klein",
    medium: "Middel",
    large: "Groot",
    whoCanSpin: "Wie Kan Het Wiel Draaien",
    allPlayers: "Alle Spelers (Beurt Gebaseerd)",
    hostOnly: "Alleen Host",
    wheelTheme: "Wiel Thema",
    classic: "Klassiek",
    neon: "Neon",
    pastel: "Pastel",
    monochrome: "Zwart-Wit",
    turnOrder: "Beurt Volgorde",
    sequential: "Opeenvolgend (Volgende Speler)",
    random: "Willekeurig",
    
    // Default wheel segments
    defaultSegments: [
      "Neem een shot",
      "Drink 5 seconden",
      "Waarheid of uitdaging",
      "Sla je beurt over",
      "Iedereen drinkt",
      "Kies iemand om te drinken",
      "Maak je drankje af",
      "Neem 2 slokken"
    ],
    
    // Error messages
    roomNotFound: "Kamer Niet Gevonden",
    roomNotFoundText: "De spelkamer die je zoekt bestaat niet.",
    backToHome: "Terug Naar Home",
    roomLimitReached: "Premium gebruikers kunnen tot 6 actieve kamers beheren. Sluit enkele kamers voordat je een nieuwe aanmaakt.",
    
    // Loading
    loading: "Laden...",
    creatingRoom: "Kamer maken...",
    
    // QR Code
    scanToJoin: "Scan om Mee Te Doen",
    
    // Room Management
    myRooms: "Mijn Kamers",
    totalRooms: "Totaal Kamers",
    activeRooms: "Actieve Kamers",
    totalPlayers: "Totaal Spelers",
    noRoomsYet: "Nog geen kamers",
    createFirstRoom: "Maak je eerste kamer om te beginnen!",
    active: "Actief",
    inactive: "Inactief",
    created: "Gemaakt",
    players: "Spelers",
    type: "Type",
    lastActivity: "Laatste Activiteit",
    deactivate: "Deactiveren",
    reactivate: "Reactiveren",
    delete: "Verwijderen",
    confirmDeactivateRoom: "Weet je zeker dat je deze kamer wilt deactiveren?",
    confirmDeleteRoom: "Weet je zeker dat je deze kamer permanent wilt verwijderen?",
    errorDeactivatingRoom: "Kon kamer niet deactiveren. Probeer opnieuw.",
    errorReactivatingRoom: "Kon kamer niet reactiveren. Probeer opnieuw.",
    errorDeletingRoom: "Kon kamer niet verwijderen. Probeer opnieuw.",
    manageRooms: "Kamers Beheren",
    public: "Openbaar",
    private: "Privé"
  },

  es: {
    // Home Page
    title: "Parteezy",
    subtitle: "El Juego de Fiesta Definitivo",
    createRoom: "Crear Sala",
    joinRoom: "Unirse a Sala",
    enterRoomCode: "Ingresa Código de Sala",
    howToPlay: "Cómo Jugar",
    howToPlayText: "¡Crea una sala, invita amigos y túrnense girando la rueda para verdad o reto, desafíos de bebida y juegos de fiesta divertidos!",
    copyright: "© 2024 Parteezy - Bebe Responsablemente",
    
    // Payment Page
    paymentTitle: "Parteezy Premium",
    securePayment: "🔒 Procesamiento de Pago Seguro",
    securePaymentDesc: "Todos los pagos se procesan de forma segura a través de Stripe. Tu información de pago está encriptada y nunca se almacena en nuestros servidores.",
    addToCart: "Añadir al Carrito",
    addedToCart: "✓ Añadido al Carrito",
    adding: "Añadiendo...",
    cart: "Carrito",
    
    // Private Room
    privateRoom: "Sala Privada",
    premium: "(Premium)",
    enterRoomPassword: "Ingresa contraseña de sala",
    createPrivateRoom: "🔒 Crear Sala Privada",
    roomPassword: "Contraseña de Sala",
    passwordRequired: "Se requiere contraseña para salas privadas",
    incorrectPassword: "Contraseña incorrecta. Inténtalo de nuevo.",
    enterPassword: "Ingresa Contraseña",
         privateRoomAlert: "¡Las salas privadas son una función Premium! Actualiza para crear salas protegidas con contraseña.",
     privateRoomDescription: "Esta es una sala privada. Ingresa la contraseña para continuar.",
    
    // Language Switcher
    selectLanguage: "Seleccionar Idioma",
    
    // Join Modal
    joinTheGame: "Únete al Juego",
    enterYourName: "Ingresa Tu Nombre",
    chooseProfilePicture: "Elige Foto de Perfil (opcional)",
    cancel: "Cancelar",
    joinGame: "Unirse al Juego",
    joining: "Uniéndose...",
    nameRequired: "Por favor ingresa tu nombre",
    failedToJoin: "Error al unirse a la sala. Inténtalo de nuevo.",
    
    // Game Room
    roomCode: "Código de Sala",
    leaveRoom: "Salir de Sala",
    currentTurn: "Turno Actual",
    you: "(Tú)",
    spinning: "Girando...",
    
    // Player List
    players: "Jugadores",
    host: "Anfitrión",
    currentTurnBadge: "Turno Actual",
    away: "Ausente",
    offline: "Desconectado",
    joiningBadge: "Uniéndose...",
    noPlayersYet: "Aún no se han unido jugadores",
    
    // Spin Wheel
    spinTheWheel: "Girar la Rueda",
    wheelSpinning: "Rueda Girando...",
    soloPlay: "Girar la Rueda (Juego Solo)",
    hostSpin: "Girar la Rueda (Anfitrión)",
    yourTurn: "Es Tu Turno - ¡Gira!",
    waitingForPlayer: "Esperando Turno del Jugador",
    waitingForHost: "Esperando que el Anfitrión Gire",
    waitingForCurrent: "Esperando a",
    waitingForNext: "Esperando al Siguiente Jugador",
    
    // Controls
    customizeWheel: "Personalizar Rueda",
    gameSettings: "Configuración del Juego",
    nextTurn: "Siguiente Turno",
    
    // Result Popup
    spinResult: "Resultado del Giro",
    awesome: "¡Increíble!",
    letsGo: "¡Vamos!",
    cheers: "¡Salud!",
    
    // Wheel Configuration
    wheelConfiguration: "Configuración de Rueda",
    addSegment: "Añadir Segmento",
    segmentText: "Texto del Segmento",
    segmentColor: "Color del Segmento",
    removeSegment: "Eliminar",
    save: "Guardar",
    close: "Cerrar",
    
    // Game Settings
    gameSettingsTitle: "Configuración del Juego ⚙️",
    wheelSize: "Tamaño de Rueda",
    small: "Pequeño",
    medium: "Mediano",
    large: "Grande",
    whoCanSpin: "Quién Puede Girar la Rueda",
    allPlayers: "Todos los Jugadores (Por Turnos)",
    hostOnly: "Solo Anfitrión",
    wheelTheme: "Tema de Rueda",
    classic: "Clásico",
    neon: "Neón",
    pastel: "Pastel",
    monochrome: "Monocromático",
    turnOrder: "Orden de Turnos",
    sequential: "Secuencial (Siguiente Jugador)",
    random: "Aleatorio",
    
    // Default wheel segments
    defaultSegments: [
      "Toma un shot",
      "Bebe por 5 segundos",
      "Verdad o reto",
      "Salta tu turno",
      "Todos beben",
      "Elige a alguien para beber",
      "Termina tu bebida",
      "Toma 2 sorbos"
    ],
    
    // Error messages
    roomNotFound: "Sala No Encontrada",
    roomNotFoundText: "La sala de juego que buscas no existe.",
    backToHome: "Volver al Inicio",
    roomLimitReached: "Los usuarios Premium pueden gestionar hasta 6 salas activas. Cierra algunas salas antes de crear una nueva.",
    
    // Loading
    loading: "Cargando...",
    creatingRoom: "Creando sala...",
    
    // QR Code
    scanToJoin: "Escanea para Unirte",
    
    // Room Management
    myRooms: "Mis Salas",
    totalRooms: "Total de Salas",
    activeRooms: "Salas Activas",
    totalPlayers: "Total de Jugadores",
    noRoomsYet: "Aún no hay salas",
    createFirstRoom: "¡Crea tu primera sala para comenzar!",
    active: "Activo",
    inactive: "Inactivo",
    created: "Creado",
    players: "Jugadores",
    type: "Tipo",
    lastActivity: "Última Actividad",
    deactivate: "Desactivar",
    reactivate: "Reactivar",
    delete: "Eliminar",
    confirmDeactivateRoom: "¿Estás seguro de que quieres desactivar esta sala?",
    confirmDeleteRoom: "¿Estás seguro de que quieres eliminar permanentemente esta sala?",
    errorDeactivatingRoom: "No se pudo desactivar la sala. Inténtalo de nuevo.",
    errorReactivatingRoom: "No se pudo reactivar la sala. Inténtalo de nuevo.",
    errorDeletingRoom: "No se pudo eliminar la sala. Inténtalo de nuevo.",
    manageRooms: "Gestionar Salas",
    public: "Público",
    private: "Privado"
  },

  fr: {
    // Home Page
    title: "Parteezy",
    subtitle: "Le Jeu de Fête Ultime",
    createRoom: "Créer une Salle",
    joinRoom: "Rejoindre une Salle",
    enterRoomCode: "Entrez le Code de Salle",
    howToPlay: "Comment Jouer",
    howToPlayText: "Créez une salle, invitez des amis et alternez en faisant tourner la roue pour action ou vérité, défis de boisson et jeux de fête amusants!",
    copyright: "© 2024 Parteezy - Buvez Responsablement",
    
    // Payment Page
    paymentTitle: "Parteezy Premium",
    securePayment: "🔒 Traitement de Paiement Sécurisé",
    securePaymentDesc: "Tous les paiements sont traités de manière sécurisée via Stripe. Vos informations de paiement sont cryptées et jamais stockées sur nos serveurs.",
    addToCart: "Ajouter au Panier",
    addedToCart: "✓ Ajouté au Panier",
    adding: "Ajout...",
    cart: "Panier",
    
    // Private Room
    privateRoom: "Salle Privée",
    premium: "(Premium)",
    enterRoomPassword: "Entrez le mot de passe de la salle",
    createPrivateRoom: "🔒 Créer une Salle Privée",
    roomPassword: "Mot de Passe de Salle",
    passwordRequired: "Un mot de passe est requis pour les salles privées",
    incorrectPassword: "Mot de passe incorrect. Veuillez réessayer.",
    enterPassword: "Entrez le Mot de Passe",
         privateRoomAlert: "Les salles privées sont une fonctionnalité Premium! Mettez à niveau pour créer des salles protégées par mot de passe.",
     privateRoomDescription: "Ceci est une salle privée. Veuillez entrer le mot de passe pour continuer.",
    
    // Language Switcher
    selectLanguage: "Sélectionner la Langue",
    
    // Join Modal
    joinTheGame: "Rejoindre le Jeu",
    enterYourName: "Entrez Votre Nom",
    chooseProfilePicture: "Choisir une Photo de Profil (optionnel)",
    cancel: "Annuler",
    joinGame: "Rejoindre le Jeu",
    joining: "Rejoindre...",
    nameRequired: "Veuillez entrer votre nom",
    failedToJoin: "Échec de rejoindre la salle. Veuillez réessayer.",
    
    // Game Room
    roomCode: "Code de Salle",
    leaveRoom: "Quitter la Salle",
    currentTurn: "Tour Actuel",
    you: "(Vous)",
    spinning: "Tournant...",
    
    // Player List
    players: "Joueurs",
    host: "Hôte",
    currentTurnBadge: "Tour Actuel",
    away: "Absent",
    offline: "Hors Ligne",
    joiningBadge: "Rejoindre...",
    noPlayersYet: "Aucun joueur n'a encore rejoint",
    
    // Spin Wheel
    spinTheWheel: "Faire Tourner la Roue",
    wheelSpinning: "Roue en Rotation...",
    soloPlay: "Faire Tourner la Roue (Jeu Solo)",
    hostSpin: "Faire Tourner la Roue (Hôte)",
    yourTurn: "C'est Votre Tour - Tournez!",
    waitingForPlayer: "En Attente du Tour du Joueur",
    waitingForHost: "En Attente que l'Hôte Tourne",
    waitingForCurrent: "En attente de",
    waitingForNext: "En Attente du Joueur Suivant",
    
    // Controls
    customizeWheel: "Personnaliser la Roue",
    gameSettings: "Paramètres du Jeu",
    nextTurn: "Tour Suivant",
    
    // Result Popup
    spinResult: "Résultat du Tour",
    awesome: "Fantastique!",
    letsGo: "Allons-y!",
    cheers: "Santé!",
    
    // Wheel Configuration
    wheelConfiguration: "Configuration de la Roue",
    addSegment: "Ajouter un Segment",
    segmentText: "Texte du Segment",
    segmentColor: "Couleur du Segment",
    removeSegment: "Supprimer",
    save: "Sauvegarder",
    close: "Fermer",
    
    // Game Settings
    gameSettingsTitle: "Paramètres du Jeu ⚙️",
    wheelSize: "Taille de la Roue",
    small: "Petit",
    medium: "Moyen",
    large: "Grand",
    whoCanSpin: "Qui Peut Faire Tourner la Roue",
    allPlayers: "Tous les Joueurs (Par Tours)",
    hostOnly: "Hôte Seulement",
    wheelTheme: "Thème de la Roue",
    classic: "Classique",
    neon: "Néon",
    pastel: "Pastel",
    monochrome: "Monochrome",
    turnOrder: "Ordre des Tours",
    sequential: "Séquentiel (Joueur Suivant)",
    random: "Aléatoire",
    
    // Default wheel segments
    defaultSegments: [
      "Prendre un shot",
      "Boire pendant 5 secondes",
      "Action ou vérité",
      "Passer votre tour",
      "Tout le monde boit",
      "Choisir quelqu'un pour boire",
      "Finir votre verre",
      "Prendre 2 gorgées"
    ],
    
    // Error messages
    roomNotFound: "Salle Non Trouvée",
    roomNotFoundText: "La salle de jeu que vous cherchez n'existe pas.",
    backToHome: "Retour à l'Accueil",
    roomLimitReached: "Les utilisateurs Premium peuvent gérer jusqu'à 6 salles actives. Fermez quelques salles avant d'en créer une nouvelle.",
    
    // Loading
    loading: "Chargement...",
    creatingRoom: "Création de salle...",
    
    // QR Code
    scanToJoin: "Scanner pour Rejoindre",
    
    // Room Management
    myRooms: "Mes Salles",
    totalRooms: "Total des Salles",
    activeRooms: "Salles Actives",
    totalPlayers: "Total des Joueurs",
    noRoomsYet: "Aucune salle pour le moment",
    createFirstRoom: "Créez votre première salle pour commencer!",
    active: "Actif",
    inactive: "Inactif",
    created: "Créé",
    players: "Joueurs",
    type: "Type",
    lastActivity: "Dernière Activité",
    deactivate: "Désactiver",
    reactivate: "Réactiver",
    delete: "Supprimer",
    confirmDeactivateRoom: "Êtes-vous sûr de vouloir désactiver cette salle?",
    confirmDeleteRoom: "Êtes-vous sûr de vouloir supprimer définitivement cette salle?",
    errorDeactivatingRoom: "Impossible de désactiver la salle. Veuillez réessayer.",
    errorReactivatingRoom: "Impossible de réactiver la salle. Veuillez réessayer.",
    errorDeletingRoom: "Impossible de supprimer la salle. Veuillez réessayer.",
    manageRooms: "Gérer les Salles",
    public: "Public",
    private: "Privé"
  },

  de: {
    // Home Page
    title: "Parteezy",
    subtitle: "Das Ultimative Partyspiel",
    createRoom: "Raum Erstellen",
    joinRoom: "Raum Beitreten",
    enterRoomCode: "Raumcode Eingeben",
    howToPlay: "Wie zu Spielen",
    howToPlayText: "Erstelle einen Raum, lade Freunde ein und wechselt euch beim Drehen des Rads für Wahrheit oder Pflicht, Trinkherausforderungen und lustige Partyspiele ab!",
    copyright: "© 2024 Parteezy - Trinkt Verantwortlich",
    
    // Payment Page
    paymentTitle: "Parteezy Premium",
    securePayment: "🔒 Sichere Zahlungsabwicklung",
    securePaymentDesc: "Alle Zahlungen werden sicher über Stripe abgewickelt. Ihre Zahlungsinformationen sind verschlüsselt und werden niemals auf unseren Servern gespeichert.",
    addToCart: "In den Warenkorb",
    addedToCart: "✓ In Warenkorb Hinzugefügt",
    adding: "Hinzufügen...",
    cart: "Warenkorb",
    
    // Private Room
    privateRoom: "Privater Raum",
    premium: "(Premium)",
    enterRoomPassword: "Raum-Passwort eingeben",
    createPrivateRoom: "🔒 Privaten Raum Erstellen",
    roomPassword: "Raum-Passwort",
    passwordRequired: "Passwort ist für private Räume erforderlich",
    incorrectPassword: "Falsches Passwort. Bitte versuchen Sie es erneut.",
    enterPassword: "Passwort Eingeben",
         privateRoomAlert: "Private Räume sind eine Premium-Funktion! Upgraden Sie, um passwortgeschützte Räume zu erstellen.",
     privateRoomDescription: "Dies ist ein privater Raum. Bitte geben Sie das Passwort ein, um fortzufahren.",
    
    // Language Switcher
    selectLanguage: "Sprache Auswählen",
    
    // Join Modal
    joinTheGame: "Dem Spiel Beitreten",
    enterYourName: "Ihren Namen Eingeben",
    chooseProfilePicture: "Profilbild Wählen (optional)",
    cancel: "Abbrechen",
    joinGame: "Spiel Beitreten",
    joining: "Beitritt...",
    nameRequired: "Bitte geben Sie Ihren Namen ein",
    failedToJoin: "Fehler beim Beitritt zum Raum. Bitte versuchen Sie es erneut.",
    
    // Game Room
    roomCode: "Raumcode",
    leaveRoom: "Raum Verlassen",
    currentTurn: "Aktueller Zug",
    you: "(Sie)",
    spinning: "Dreht sich...",
    
    // Player List
    players: "Spieler",
    host: "Gastgeber",
    currentTurnBadge: "Aktueller Zug",
    away: "Abwesend",
    offline: "Offline",
    joiningBadge: "Beitritt...",
    noPlayersYet: "Noch keine Spieler beigetreten",
    
    // Spin Wheel
    spinTheWheel: "Das Rad Drehen",
    wheelSpinning: "Rad Dreht Sich...",
    soloPlay: "Das Rad Drehen (Solo-Spiel)",
    hostSpin: "Das Rad Drehen (Gastgeber)",
    yourTurn: "Sie Sind Dran - Drehen!",
    waitingForPlayer: "Warten auf Spielerzug",
    waitingForHost: "Warten darauf, dass Gastgeber dreht",
    waitingForCurrent: "Warten auf",
    waitingForNext: "Warten auf Nächsten Spieler",
    
    // Controls
    customizeWheel: "Rad Anpassen",
    gameSettings: "Spieleinstellungen",
    nextTurn: "Nächster Zug",
    
    // Result Popup
    spinResult: "Drehergebnis",
    awesome: "Fantastisch!",
    letsGo: "Los geht's!",
    cheers: "Prost!",
    
    // Wheel Configuration
    wheelConfiguration: "Rad-Konfiguration",
    addSegment: "Segment Hinzufügen",
    segmentText: "Segment-Text",
    segmentColor: "Segment-Farbe",
    removeSegment: "Entfernen",
    save: "Speichern",
    close: "Schließen",
    
    // Game Settings
    gameSettingsTitle: "Spieleinstellungen ⚙️",
    wheelSize: "Radgröße",
    small: "Klein",
    medium: "Mittel",
    large: "Groß",
    whoCanSpin: "Wer Kann Das Rad Drehen",
    allPlayers: "Alle Spieler (Rundenbasiert)",
    hostOnly: "Nur Gastgeber",
    wheelTheme: "Rad-Thema",
    classic: "Klassisch",
    neon: "Neon",
    pastel: "Pastell",
    monochrome: "Monochrom",
    turnOrder: "Zugreihenfolge",
    sequential: "Sequenziell (Nächster Spieler)",
    random: "Zufällig",
    
    // Default wheel segments
    defaultSegments: [
      "Einen Shot nehmen",
      "5 Sekunden trinken",
      "Wahrheit oder Pflicht",
      "Zug überspringen",
      "Alle trinken",
      "Jemanden zum Trinken wählen",
      "Getränk austrinken",
      "2 Schlücke nehmen"
    ],
    
    // Error messages
    roomNotFound: "Raum Nicht Gefunden",
    roomNotFoundText: "Der Spielraum, den Sie suchen, existiert nicht.",
    backToHome: "Zurück zur Startseite",
    roomLimitReached: "Premium-Benutzer können bis zu 6 aktive Räume verwalten. Schließen Sie einige Räume, bevor Sie einen neuen erstellen.",
    
    // Loading
    loading: "Laden...",
    creatingRoom: "Raum erstellen...",
    
    // QR Code
    scanToJoin: "Scannen zum Beitreten",
    
    // Room Management
    myRooms: "Meine Räume",
    totalRooms: "Gesamte Räume",
    activeRooms: "Aktive Räume",
    totalPlayers: "Gesamte Spieler",
    noRoomsYet: "Noch keine Räume",
    createFirstRoom: "Erstelle deinen ersten Raum um zu beginnen!",
    active: "Aktiv",
    inactive: "Inaktiv",
    created: "Erstellt",
    players: "Spieler",
    type: "Typ",
    lastActivity: "Letzte Aktivität",
    deactivate: "Deaktivieren",
    reactivate: "Reaktivieren",
    delete: "Löschen",
    confirmDeactivateRoom: "Bist du sicher, dass du diesen Raum deaktivieren möchtest?",
    confirmDeleteRoom: "Bist du sicher, dass du diesen Raum dauerhaft löschen möchtest?",
    errorDeactivatingRoom: "Raum konnte nicht deaktiviert werden. Bitte versuche es erneut.",
    errorReactivatingRoom: "Raum konnte nicht reaktiviert werden. Bitte versuche es erneut.",
    errorDeletingRoom: "Raum konnte nicht gelöscht werden. Bitte versuche es erneut.",
    manageRooms: "Räume Verwalten",
    public: "Öffentlich",
    private: "Privat"
  },

  zh: {
    // Home Page
    title: "Parteezy",
    subtitle: "终极派对游戏",
    createRoom: "创建房间",
    joinRoom: "加入房间",
    enterRoomCode: "输入房间代码",
    howToPlay: "如何游戏",
    howToPlayText: "创建房间，邀请朋友，轮流转动轮盘进行真心话大冒险、饮酒挑战和有趣的派对游戏！",
    copyright: "© 2024 Parteezy - 负责任饮酒",
    
    // Payment Page
    paymentTitle: "Parteezy 高级版",
    securePayment: "🔒 安全支付处理",
    securePaymentDesc: "所有支付都通过 Stripe 安全处理。您的支付信息经过加密，绝不会存储在我们的服务器上。",
    addToCart: "添加到购物车",
    addedToCart: "✓ 已添加到购物车",
    adding: "添加中...",
    cart: "购物车",
    
    // Private Room
    privateRoom: "私人房间",
    premium: "（高级版）",
    enterRoomPassword: "输入房间密码",
    createPrivateRoom: "🔒 创建私人房间",
    roomPassword: "房间密码",
    passwordRequired: "私人房间需要密码",
    incorrectPassword: "密码错误。请重试。",
    enterPassword: "输入密码",
         privateRoomAlert: "私人房间是高级版功能！升级以创建密码保护的房间。",
     privateRoomDescription: "这是一个私人房间。请输入密码以继续。",
    
    // Language Switcher
    selectLanguage: "选择语言",
    
    // Join Modal
    joinTheGame: "加入游戏",
    enterYourName: "输入您的姓名",
    chooseProfilePicture: "选择头像（可选）",
    cancel: "取消",
    joinGame: "加入游戏",
    joining: "正在加入...",
    nameRequired: "请输入您的姓名",
    failedToJoin: "加入房间失败。请重试。",
    
    // Game Room
    roomCode: "房间代码",
    leaveRoom: "离开房间",
    currentTurn: "当前回合",
    you: "（您）",
    spinning: "转动中...",
    
    // Player List
    players: "玩家",
    host: "房主",
    currentTurnBadge: "当前回合",
    away: "离开",
    offline: "离线",
    joiningBadge: "正在加入...",
    noPlayersYet: "还没有玩家加入",
    
    // Spin Wheel
    spinTheWheel: "转动轮盘",
    wheelSpinning: "轮盘转动中...",
    soloPlay: "转动轮盘（单人游戏）",
    hostSpin: "转动轮盘（房主）",
    yourTurn: "轮到您了 - 转动！",
    waitingForPlayer: "等待玩家回合",
    waitingForHost: "等待房主转动",
    waitingForCurrent: "等待",
    waitingForNext: "等待下一个玩家",
    
    // Controls
    customizeWheel: "自定义轮盘",
    gameSettings: "游戏设置",
    nextTurn: "下一回合",
    
    // Result Popup
    spinResult: "转动结果",
    awesome: "太棒了！",
    letsGo: "开始吧！",
    cheers: "干杯！",
    
    // Wheel Configuration
    wheelConfiguration: "轮盘配置",
    addSegment: "添加片段",
    segmentText: "片段文本",
    segmentColor: "片段颜色",
    removeSegment: "移除",
    save: "保存",
    close: "关闭",
    
    // Game Settings
    gameSettingsTitle: "游戏设置 ⚙️",
    wheelSize: "轮盘大小",
    small: "小",
    medium: "中",
    large: "大",
    whoCanSpin: "谁可以转动轮盘",
    allPlayers: "所有玩家（按回合）",
    hostOnly: "仅房主",
    wheelTheme: "轮盘主题",
    classic: "经典",
    neon: "霓虹灯",
    pastel: "粉彩",
    monochrome: "单色",
    turnOrder: "回合顺序",
    sequential: "顺序（下一个玩家）",
    random: "随机",
    
    // Default wheel segments
    defaultSegments: [
      "喝一杯",
      "喝5秒钟",
      "真心话大冒险",
      "跳过回合",
      "大家都喝",
      "选择某人喝酒",
      "喝完你的酒",
      "喝2口"
    ],
    
    // Error messages
    roomNotFound: "房间未找到",
    roomNotFoundText: "您寻找的游戏房间不存在。",
    backToHome: "返回首页",
    roomLimitReached: "高级版用户最多可以管理6个活跃房间。创建新房间前请先关闭一些房间。",
    
    // Loading
    loading: "加载中...",
    creatingRoom: "创建房间中...",
    
    // QR Code
    scanToJoin: "扫描加入",
    
    // Room Management
    myRooms: "我的房间",
    totalRooms: "总房间数",
    activeRooms: "活跃房间",
    totalPlayers: "总玩家数",
    noRoomsYet: "还没有房间",
    createFirstRoom: "创建你的第一个房间开始吧！",
    active: "活跃",
    inactive: "非活跃",
    created: "创建时间",
    players: "玩家",
    type: "类型",
    lastActivity: "最后活动",
    deactivate: "停用",
    reactivate: "重新激活",
    delete: "删除",
    confirmDeactivateRoom: "您确定要停用此房间吗？",
    confirmDeleteRoom: "您确定要永久删除此房间吗？",
    errorDeactivatingRoom: "无法停用房间。请重试。",
    errorReactivatingRoom: "无法重新激活房间。请重试。",
    errorDeletingRoom: "无法删除房间。请重试。",
    manageRooms: "管理房间",
    public: "公开",
    private: "私人"
  }
};